import { useAppDispatch } from 'Src/hooks'
import { deviceSlice } from 'Modules/DeviceDetect'
import { useEffect } from 'react'
import { isMobileDevice, isTabletDevice } from 'Pages/orders_design'

const actions = {
	setIsMobile: deviceSlice.actions.setIsMobile,
	setIsTablet: deviceSlice.actions.setIsTablet,
}

export const DeviceDetectComponent = () => {
	const { setIsMobile, setIsTablet } = useAppDispatch(actions)

	useEffect(() => {
		setIsTablet(isTabletDevice())
		setIsMobile(isMobileDevice())
	}, [])

	return null
}
